import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PRESETS } from './PromotionalCard.presets';

export const StyledPromotionalCard = styled.div<{
  imageUrl: string;
  height: number;
  width: number;
}>`
  ${({ theme, imageUrl, height, width }) =>
    `
      width: ${utils.rem(width)};
      height: ${utils.rem(height)};
      .ant-card {
        background: url(${imageUrl});
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        & .ant-card-body {
          width: 100%;
          padding: ${utils.rem(theme.Spacing.Size.Small)} ${utils.rem(
      theme.Spacing.Size.MediumSmall
    )};
          background: ${theme.Color.NeutralsFixed.Text};
          position: absolute;
          bottom: ${utils.rem(PRESETS.card.body.bottom)};
          & .ant-card-meta-detail {
            display: flex;
            flex-direction: column;
            gap: ${utils.rem(theme.Border.Size.Medium)}
          };
          transition: ${theme.Transition.Timing.Out};
        };
        :hover {
          box-shadow: none;
          & .ant-card-body {
            padding: ${utils.rem(theme.Spacing.Size.MediumSmall)};
          };
        }
      };
  `}
`;
